import { render, staticRenderFns } from "./SecondaryInsurance.vue?vue&type=template&id=24f69fa6&scoped=true&"
import script from "./SecondaryInsurance.vue?vue&type=script&lang=js&"
export * from "./SecondaryInsurance.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryInsurance.vue?vue&type=style&index=0&id=24f69fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f69fa6",
  null
  
)

export default component.exports